import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import { monthOptions, yearOptions } from "../CheckinCheckoutReport/CheckinCheckoutData";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";

const MonthlyStatusReport = () => {

    const [open, setOpen] = useState(false);
    const [confirmationDialog, setConfirmationDialog] = useState({
        open: false,
        title: "",
        message: "",
        showCancel: true,
        showConfirm: true,
        customSection: null,
        onConfirm: () => {},
        onCancel: () => {},
    });
    const [inputData, setInputData] = useState({
        month: "", 
        year: "",
    });

    // On Click API Function
    const handleDownloadReport = async() => {
        try{
            const response = await axios.post(
                BASEURL,
                {
                    query: `
                        query MonthlyUserAttendanceSummary($month: Int!, $year: Int!) {
                            monthlyUserAttendanceSummary(month: $month, year: $year) {
                                empid
                                firstName
                                lastName
                                shift
                                attendance {
                                    date
                                    checkIn
                                    checkOut
                                    totalWorkingHours
                                    status
                                }
                            }
                        }
                    `,
                    variables: {
                        month: parseInt(inputData.month.value),
                        year: inputData.year.value,
                    },
                },
                {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer YOUR_TOKEN_HERE`,
                    },
                }
            );
            const responseData = response.data.data.monthlyUserAttendanceSummary;            
            if(responseData.length > 0) {
                handleDownloadPdf(responseData, inputData?.month?.label, inputData?.year?.value);
            } else {
                setOpen(false);
                setConfirmationDialog({
                    open: true,
                    title: "Notice",
                    message: "No records were found for the selected year and month.",
                    showCancel: true,
                    showConfirm: false,
                    onCancel: () => {
                        setConfirmationDialog({
                        ...confirmationDialog,
                        open: false,
                        });
                    },
                });
            }
        }
        catch(error) {
            console.error("Error downloading report:", error);
            setConfirmationDialog({
                open: true,
                title: "Error message",
                message:
                "Sorry for your inconvience, there is some issue in our network. Please try again later.",
                showCancel: true,
                showConfirm: false,

                onCancel: () => {
                setConfirmationDialog({
                    ...confirmationDialog,
                    open: false,
                });
                },
            });
        }
    };

    //PDF UI and Download Function
    const handleDownloadPdf = (data, selectedMonth, selectedYear) => {
        const doc = new jsPDF();
        const today = dayjs().format("DD MMM YYYY HH:mm");
        const pageWidth = doc.internal.pageSize.getWidth();
        const marginLeft = 14;
        const labelColWidth = 12;
        const columnWidth = 5.8;
        const maxY = 280;
        const startX = marginLeft + labelColWidth;
        let y = 36;

        // -- Title
        doc.setFontSize(14);
        const title = "Monthly Status Report (Basic Work Duration)";
        const titleWidth = doc.getTextWidth(title);
        doc.text(title, (pageWidth - titleWidth) / 2, 15);
        doc.setFontSize(10);
        const startDate = dayjs(`${selectedYear}-${selectedMonth}-01`).format("DD MMM YYYY");
        const endDate = dayjs(`${selectedYear}-${selectedMonth}-01`).endOf("month").format("DD MMM YYYY");
        const dateRangeText = `${startDate}  To  ${endDate}`;
        const dateRangeWidth = doc.getTextWidth(dateRangeText);

        doc.text(`${startDate}  To  ${endDate}`, (pageWidth - dateRangeWidth) / 2, 22);
        doc.text(`Company: EMF`, marginLeft, 25);
        doc.text(`Printed On: ${today}`, pageWidth - marginLeft, 25, { align: "right" });

        doc.setLineWidth(0.5);
        doc.line(marginLeft, 30, pageWidth - marginLeft, 30);

        const daysInMonth = dayjs(`${selectedYear}-${selectedMonth}-01`).daysInMonth();

        // -- Calendar Header Row
        doc.setFontSize(7);
        doc.text("Days:", marginLeft, y);
        for (let i = 1; i <= daysInMonth; i++) {
            const label = `${i}${dayjs(`${selectedYear}-${selectedMonth}-${i}`).format("dd")[0]}`;
            doc.text(label, startX + (i - 1) * columnWidth, y);
        }

        // -- Top & bottom line of calendar header
        y += 2;
        const calendarRowHeight = 6; // increase this slightly for height
        doc.setLineWidth(0.2);

        // Top and bottom lines for calendar table
        doc.line(marginLeft, y - calendarRowHeight, startX + (daysInMonth + 1) * columnWidth, y - calendarRowHeight); // top
        doc.line(marginLeft, y, startX + (daysInMonth + 1) * columnWidth, y); // bottom

        // Vertical lines for each date cell
        for (let i = 0; i <= daysInMonth; i++) {
        const x = startX + i * columnWidth;
        doc.line(x, y - calendarRowHeight, x, y);
        }

        y += 5; // adjust for next section


        // -- Employee Data Rows
        data.forEach((employee) => {
            if (y > maxY) {
            doc.addPage();
            y = 20;
            }

            const empName = `${employee.firstName} ${employee.lastName}`.trim() || "--";
            const attMap = {};
            employee.attendance?.forEach((a) => {
            attMap[dayjs(a.date).date()] = a;
            });

            // Emp Header
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(`Emp. Code: ${employee.empid || " - "}`, marginLeft, y);
            doc.text(`Emp. Name: ${empName}`, marginLeft + 65, y);
            doc.setFont("helvetica", "normal");
            y += 4;

            // Top border for this employee's block
            doc.line(marginLeft, y - 3, startX + daysInMonth * columnWidth, y - 3);

            const rows = ["Status", "InTime", "OutTime", "Total"];
            rows.forEach((rowLabel) => {
            doc.setFontSize(7);
            doc.text(rowLabel + ":", marginLeft, y);

            for (let i = 1; i <= daysInMonth; i++) {
                const entry = attMap[i];
                let cellText = "--";
                if (entry) {
                switch (rowLabel) {
                    case "Status":
                    cellText = entry.checkIn && entry.checkOut ? "P" : "A";
                    break;
                    case "InTime":
                    cellText = entry.checkIn ? dayjs(entry.checkIn).format("HH:mm") : " -";
                    break;
                    case "OutTime":
                    cellText = entry.checkOut ? dayjs(entry.checkOut).format("HH:mm") : " -";
                    break;
                    case "Total":
                    cellText = entry.totalWorkingHours || " -";
                    break;
                }
                }
                doc.text(cellText, startX + (i - 1) * columnWidth, y);
            }

            // Vertical & bottom lines for row
            for (let i = 0; i <= daysInMonth; i++) {
                const x = startX + i * columnWidth;
                doc.line(x, y - 3, x, y + 3); // vertical
            }
            doc.line(marginLeft, y + 3, startX + daysInMonth * columnWidth, y + 3); // horizontal

            y += 6;
            if (y > maxY) {
                doc.addPage();
                y = 20;
            }
            });

            y += 5;
        });

        doc.save(`Monthly_Status_Report_${selectedMonth}_${selectedYear}.pdf`);
    };

  return (
    <>
     {confirmationDialog.open && (
        <ConfirmationDialog
            open={confirmationDialog.open}
            title={confirmationDialog.title}
            message={confirmationDialog.message}
            showCancel={confirmationDialog.showCancel}
            showConfirm={confirmationDialog.showConfirm}
            customSection={confirmationDialog.customSection}
            onConfirm={confirmationDialog.onConfirm}
            onCancel={confirmationDialog.onCancel}
        />
    )}
        <button
        onClick={() => setOpen(true)}
        style={{
            marginBottom: "10px",
            padding: "10px 12px",
            background: "#13959eff",
            color: "#fff",
            border: "none",
            cursor: "pointer",
        }}
        >
        Monthly Status Report
        </button>
        <Dialog open={open} onClose={() => {
            setOpen(false);
            setInputData({
                month: "",
                year: "",
            });
        }}>
            <DialogTitle>
                Monthly Status Report
            </DialogTitle>
            <DialogContent>
                 <MaterialBox mb={10}>
                    <Grid container spacing={2}>
                        <Grid size={{ lg: 12, md:12, xs: 12, sm: 12 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                                <MaterialTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold">
                                        Choose Year
                                    </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                            value={inputData.year}
                            onChange={(e) => setInputData({ ...inputData, year: e })}
                            options={yearOptions}
                            name="year"
                            placeholder="Select Year"
                            menuPlacement="auto"
                            />
                        </Grid>
                        <Grid size={{ lg:12, md: 12, xs: 12, sm: 12 }}>
                            <MaterialBox lineHeight={0} display="inline-block">
                                <MaterialTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold"
                                >
                                    Choose Month
                                </MaterialTypography>
                            </MaterialBox>
                            <MaterialSelect
                            value={inputData.month}
                            onChange={(e) => setInputData({ ...inputData, month: e })}
                            options={monthOptions}
                            name="month"
                            placeholder="Select Month"
                            menuPlacement="auto"
                            />
                        </Grid>
                        
                    </Grid>
                </MaterialBox>
            </DialogContent>
            <DialogActions>
                <MaterialButton
                variant="gradient"
                color="dark"
                disabled={!inputData.month || !inputData.year}
                onClick={() => {
                    handleDownloadReport();
                }}>
                    Download Report
                </MaterialButton>
            </DialogActions>
        </Dialog>
    </>
  )
}

export default MonthlyStatusReport